"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealOmeletteLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealOmeletteLinear = function MealOmeletteLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.436 7.057c3.486-2.294 8.195-.517 9.296 3.508l.789 2.883a5.19 5.19 0 001.548 2.501l3.066 2.738c3.85 3.439 1.418 9.813-3.744 9.813a3.62 3.62 0 00-3.49 2.654l-.963-.267.964.267-.043.154c-1.26 4.55-7.125 5.792-10.123 2.145l-.46-.56a4.208 4.208 0 00-2.707-1.501l-2.402-.313A11.605 11.605 0 013.12 20.727C2.457 14.11 7.48 8.29 14.125 7.978l5.23-.244a4.139 4.139 0 002.081-.677zm7.367 4.036c-.742-2.714-3.917-3.912-6.267-2.366a6.138 6.138 0 01-3.088 1.004l-5.23.245c-5.499.257-9.657 5.074-9.108 10.552a9.605 9.605 0 008.316 8.568l2.401.313a6.208 6.208 0 013.993 2.213l.461.56c1.97 2.397 5.822 1.58 6.65-1.409l.964.267-.963-.267.042-.154a5.62 5.62 0 015.417-4.12c3.325 0 4.892-4.105 2.412-6.32l-3.066-2.738a7.19 7.19 0 01-2.145-3.466l-.789-2.882zM19 15a5 5 0 100 10 5 5 0 000-10zm-7 5a7 7 0 1114 0 7 7 0 01-14 0zm9-1a1 1 0 011 1 3 3 0 01-3 3 1 1 0 110-2 1 1 0 001-1 1 1 0 011-1z",
    fill: "#95A0B3"
  }));
};

exports.MealOmeletteLinear = MealOmeletteLinear;
var _default = MealOmeletteLinear;
exports.default = _default;